import { type UseMutationOptions, useMutation } from '@tanstack/react-query';
import {
  type CreateCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsPostData,
  type CreateCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsPostError,
  type CreateCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsPostResponse,
  createCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsPost,
} from '../../generated';

export type CreateCollectionMutationVariables =
  CreateCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsPostData['path'] &
    CreateCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsPostData['body'];

export type CreateCollectionMutation = CreateCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsPostResponse;

export const useCreateCollectionMutation = <
  TError = CreateCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsPostError,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<CreateCollectionMutation, TError, CreateCollectionMutationVariables, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) => {
  return useMutation<CreateCollectionMutation, TError, CreateCollectionMutationVariables, TContext>({
    mutationKey: ['CreateCollection'],
    mutationFn: async ({ portfolio_id, ...body }: CreateCollectionMutationVariables) => {
      const { data } = await createCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsPost({
        path: { portfolio_id },
        body,
        throwOnError: true,
      });
      return data;
    },
    ...options,
  });
};

useCreateCollectionMutation.fetcher = (
  { portfolio_id, ...body }: CreateCollectionMutationVariables,
  _headers?: RequestInit['headers'],
) => {
  return async () => {
    const { data } = await createCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsPost({
      path: { portfolio_id },
      body,
      throwOnError: true,
    });
    return data;
  };
};
